const giftCardReferences = [
  '990100',
  '990150',
  '990250',
  '990350',
  '990500',
  '991000',
];
export { giftCardReferences };
